export default class BaseService {
  constructor() { }

  _setInterceptors() { }

  async _handleResponse_(response: any) {
    if (response.ok) {
      return await response.text().then((text: string) => {
        let data;

        try {
          data = text && JSON.parse(text);
        } catch (e) {
          data = text;
        }
        return data;
      });
    }

    return {
      statusCode: response.status,
      errorMessage: `Status code ${response.status}`,
    };
  }

  _handleError_(error: any) {
    console.log("error", error);
    return error;
  }

  /**
   * Communication with the API
   * @param {*} url
   * @param {*} method
   * @param {*} body
   * @param {*} contentType
   */
  async callApi(url: string, method: string, body: any = null, headers: any = null) {
    const options: any = {
      method: method,
    };

    // Construir headers base
    let baseHeaders: any = {
      Authorization:
        "Basic " +
        btoa(
          `${window.redseats.publicKey}:${window.redseats?.privateKey ?? ""}`
        ),
    };

    // Si se pasan headers, fusionar con baseHeaders (headers puede incluir Content-Type personalizado)
    if (headers !== null) {
      options.headers = { ...baseHeaders, ...headers };
      // Si NO viene Content-Type en los headers, agregar application/json por defecto
      if (!('Content-Type' in options.headers) && !('content-type' in options.headers)) {
        options.headers['Content-Type'] = 'application/json';
      }
    } else {
      // Por defecto application/json
      options.headers = { ...baseHeaders, "Content-Type": "application/json" };
    }

    // Si el Content-Type es application/gzip, no serializar body
    const contentType = options.headers["Content-Type"] || options.headers["content-type"];
    if (body !== null) {
      if (contentType && contentType.indexOf("multipart/form-data") !== -1) {
        options.body = body; // body debe ser FormData
        // fetch manejará los headers de boundary automáticamente
        delete options.headers["Content-Type"];
      } else {
        options.body = JSON.stringify(body);
      }
    }
    return await fetch(`${process.env.REACT_APP_API_URL}${url}`, options)
      .then(this._handleResponse_)
      .catch(this._handleError_);
  }

  /**
   * Communication with the API
   * @param {*} url
   * @param {*} method
   * @param {*} body
   * @param {*} contentType
   */
  async callApiFile(url: string) {
    const options = {
      method: "Get",
    };
    return await fetch(`${url}`, options)
      .then(this._handleResponse_)
      .catch(this._handleError_);
  }

  htmlError(errorMessage: string) {
    let html = document.getElementById("root");
    html.innerHTML = `<p>${errorMessage || "server error"}</p>`;
    return false;
  }
}
